import { useEffect } from 'react'
import { useAppState } from 'Context/AppContext/AppContext'
import { GoalType, useGoalsQuery } from 'Generated/graphql-types'
import { useHideNavigation } from 'Hooks/useHideNavigation'
import { Loading } from '../Academy/_common/Loading'

export const Onboarding = () => {
  const {
    nonprofitOrgConfig: { orgId: nonprofitOrgId },
  } = useAppState()

  useHideNavigation()

  const { data, loading } = useGoalsQuery({
    variables: { activeOnly: true, nonprofitOrgId, type: GoalType.Onboarding },
  })

  // This component is used as a static route for AppCues to then fetch the onboarding goal and redirect
  useEffect(() => {
    if (!loading) {
      if (data?.goals?.[0]) {
        window.location.href = `/impact/goals/${data.goals[0].id}`
      } else {
        window.location.href = '/'
      }
    }
  }, [data, loading])
  return <Loading />
}
